import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import Row from './Row';

/** @package */
export interface OrphanedSelectedFieldRowProps {
  orphanedFieldName: string;
  indentationLevel: number;
  onClick: () => void;
}

/**
 * Render a row for a field in the `GraphQLFieldSelector` component that is no longer on the schema in question.
 * Clicking on the row will remove the orphaned field from the selection set.
 *
 * `Render` `|XMark Large|...1|Field Name|...2|`, where:
 * - `|...1|` is the dynamic spacing based on `indentationLevel` prop
 * - `|...2|` is the remaining space in the row
 *
 * @package
 */
export default function OrphanedSelectedFieldRow({
  orphanedFieldName,
  indentationLevel,
  onClick,
}: OrphanedSelectedFieldRowProps): JSX.Element {
  return (
    <Row
      checkbox={
        <div className={css(styles.checkboxContainer)}>
          <BenchlingIcon icon="delete" color="red" />
        </div>
      }
      expandIcon={null}
      typeIcon={null}
      indentationLevel={indentationLevel}
      text={<span style={{color: 'red'}}>{`${orphanedFieldName} (no longer valid)`}</span>}
      onClick={onClick}
    />
  );
}

const styles = StyleSheet.create({
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
  },
});
